import { createAsyncThunk } from "@reduxjs/toolkit";
import Cookies from "universal-cookie";
import axiosInstance from "../../../../axios";
import { sendEmailOtpService } from "services/adminServices";
import {verifyEmailOtpService} from "services/adminServices";
import { getAdminDataByEmail } from "services/adminServices";

const cookies = new Cookies();

export const clearError = (state) => {
      state.error = '';
      state.otpError = '';
};

// Send OTP
export const sendEmailOtp = createAsyncThunk(
  'auth/sendEmailOtp',
  async (payload) => {
    
      const response = await sendEmailOtpService(payload);
      console.log("sendEmailOtp response:", response);
      
      return response;
    } 
);

// Verify OTP
// In actionCreator.js, update the verifyEmailOtp action
export const verifyEmailOtp = createAsyncThunk(
  'auth/verifyEmailOtp',
  async (payload , {dispatch}) => {
    try {
      console.log("Verify OTP payload:", payload);
      const response = await verifyEmailOtpService(payload);
      // console.log("OTP verification response::", response.error.success);
      
      // Store the token in localStorage
      if (response?.status === 200) {
       const token = window.localStorage.getItem('temp_token');
        console.log("OTP verified successfully. Setting token.",token);
        window.localStorage.setItem("t_id", token);
        console.log("t_id set in localStorage:", window.localStorage.getItem("t_id"));
        
        cookies.set("t_id", token, { path: "/" })
        window.localStorage.removeItem("temp_token");
       
      }
      
      return response;
    } catch (error) {
      console.error("OTP verification error:", error);
      throw error.response?.message || 'Failed to verify OTP';
    }
  }
);

// Login Action
export const login = createAsyncThunk(`auth/login`, async (payload) => {
  if (payload.email && payload.password) {
    const response = await axiosInstance.post("/adminuser/login/", payload);

    const t_id = response.data.token;
    // window.localStorage.setItem("t_id", t_id);
    console.log("Storing temp_token:", t_id);
    
    window.localStorage.setItem("temp_token", t_id);
    // window.localStorage.setItem("t_id", t_id);
console.log("temp_token stored:", window.localStorage.getItem("temp_token"));

    const email_id = payload.email;
    window.localStorage.setItem("email_id", email_id);

    // cookies.set("t_id", t_id);
    // window.location.reload();
    return email_id;
  } else {
    alert("Please enter valid credentials");
  }
});

// Logout Action
export const logout = createAsyncThunk("auth/logout", async (_, { dispatch }) => {
  try {
    cookies.remove("t_id", { path: "/" })
    window.localStorage.removeItem("t_id");
    window.localStorage.removeItem("temp_token");
    window.localStorage.removeItem("email_id");
    
    

    // Clear all caches

    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
     // Clear all caches
    if ('caches' in window) {
      const cacheNames = await caches.keys();
      await Promise.all(cacheNames.map(name => caches.delete(name)));
    }
    const highestId = window.setTimeout(() => {
      for (let i = highestId; i >= 0; i--) {
        window.clearInterval(i);
        window.clearTimeout(i);
      }
    }, 0);

    function deleteAllCookies() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++)
        deleteCookie(cookies[i].split("=")[0]);
    }

    function setCookie(name, value, expirydays) {
      var d = new Date();
      d.setTime(d.getTime() + expirydays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = name + "=" + value + "; " + expires;
    }
    function deleteCookie(name) {
      setCookie(name, "", -1);
    }
    deleteAllCookies();
    return true;
  } catch (e) {
    
  }
});


export const fetchAdminData = createAsyncThunk(
  'auth/fetchAdminData',
  async (email, { rejectWithValue }) => {
    try {
      const response = await getAdminDataByEmail(email);
      if (response.error) {
        return rejectWithValue(response.error);
      }
      return response;
    } catch (error) {
      return rejectWithValue(error.message || 'Failed to fetch admin data');
    }
  }
);
